<template>
  <multiselect
    ref="multiselect"
    v-model="value"
    :placeholder="placeholder"
    label="name"
    :track-by="trackBy"
    :options="options"
    :multiple="true"
    :taggable="true"
    :tagPlaceholder="null"
    :selectLabel="null"
    :closeOnSelect="false"
    selectedLabel="✓"
    deselectLabel="✕"
    @close="handleClose"
  >
    <template slot="noOptions">
      La liste est vide
    </template>
    <template slot="noResult">
      Aucun élément trouvé
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect"
export default {
  components: {
    Multiselect
  },
  props: {
    trackBy: {
      type: String,
      default: null
    },
    placeholder: String,
    options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      value: []
    }
  },
  watch: {
    value: {
      handler(value) {
        this.$emit("change", value)
      },
      deep: true
    }
  },
  mounted() {
    const scrollbarOptions = {
      clipAlways: false,
      overflowBehavior: {
        x: "hidden"
      },
      className: "os-theme-dark os-theme-orange"
    }
    OverlayScrollbars(this.$refs.multiselect.$refs.list, scrollbarOptions)
  },
  methods: {
    handleClose() {
      this.$emit("multiselect-close", this.value)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.multiselect {
  width: calc((100% - 16px) / 3);
}

.multiselect__select {
  z-index: 22;
}

.multiselect__select:before {
  color: $color-secondary;
  color: var(--color-secondary, $color-secondary);
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0;
  border-color: $color-secondary transparent transparent;
  border-color: var(--color-secondary, $color-secondary) transparent transparent;
}

.multiselect__tags {
  border-radius: 0;
  max-height: 110px;
}

.multiselect__tag,
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: $color-secondary;
  background-color: var(--color-secondary, $color-secondary);
}

.multiselect__tag-icon,
.multiselect__tag-icon::after {
  color: #fff;
}

.multiselect__tag-icon::after {
  content: "✕";
  font-size: 12px;
}

.multiselect__content-wrapper {
  border-radius: 0;
}

.multiselect__option {
  background-color: #fff;
}

.multiselect__option,
.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight::after {
  color: $color-primary--dark;
  color: var(--color-primary--dark, $color-primary--dark);
  font-weight: 400;
  font-size: 0.785em;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight,
.multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #fef9f1;
}

/**
 * Custom Scroller
 */
.os-theme-orange > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle,
.os-theme-orange.os-host-transition
  > .os-scrollbar
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  background: rgba(251, 172, 46, 0.555);
}

.os-theme-orange > .os-scrollbar > .os-scrollbar-track,
.os-theme-orange.os-host-transition > .os-scrollbar > .os-scrollbar-track {
  background: rgba(238, 238, 238, 0.445);
}

.os-theme-orange
  > .os-scrollbar-horizontal
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  max-width: 16px;
}

.os-theme-orange
  > .os-scrollbar-vertical
  > .os-scrollbar-track
  > .os-scrollbar-handle {
  max-height: 16px;
}
</style>
